import {
  useState,
  type FormEvent,
} from "react";

import { useAuth } from "../../auth/AuthContext";

import "./Login.css";

export default function Login() {
  const { login } = useAuth();

  const [identifier, setIdentifier] =
    useState("");

  const [password, setPassword] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState("");

  async function handleSubmit(
    event: FormEvent,
  ) {
    event.preventDefault();

    if (
      !identifier.trim() ||
      !password
    ) {
      return;
    }

    try {
      setLoading(true);
      setError("");

      await login(
        identifier,
        password,
      );
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Não foi possível entrar.",
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="login-page">
      <form
        className="login-card"
        onSubmit={handleSubmit}
      >
        <div className="login-brand">
          <div className="login-logo">
            ☀
          </div>

          <div>
            <h1>SUNSET ONE</h1>
            <p>Gestão da Arena</p>
          </div>
        </div>

        <div className="login-heading">
          <h2>Bem-vindo</h2>

          <p>
            Entre com seu ID de acesso
            e sua senha.
          </p>
        </div>

        <label>
          ID de acesso

          <input
            type="text"
            value={identifier}
            onChange={(event) =>
              setIdentifier(
                event.target.value.toLowerCase(),
              )
            }
            placeholder="Ex.: gustavo"
            autoComplete="username"
            autoFocus
          />
        </label>

        <label>
          Senha

          <input
            type="password"
            value={password}
            onChange={(event) =>
              setPassword(
                event.target.value,
              )
            }
            placeholder="Sua senha"
            autoComplete="current-password"
          />
        </label>

        {error && (
          <div className="login-error">
            {error}
          </div>
        )}

        <button
          className="login-submit"
          type="submit"
          disabled={
            loading ||
            !identifier.trim() ||
            !password
          }
        >
          {loading
            ? "Entrando..."
            : "Entrar"}
        </button>

        <span className="login-help">
          Acesso exclusivo para
          funcionários da Arena.
        </span>
      </form>
    </main>
  );
}